import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_MATCHES_GOALS =
  'REQUEST_FETCH_STATS_MATCHES_GOALS';
export const SUCCESS_FETCH_STATS_MATCHES_GOALS =
  'SUCCESS_FETCH_STATS_MATCHES_GOALS';
export const FAIL_FETCH_STATS_MATCHES_GOALS = 'FAIL_FETCH_STATS_MATCHES_GOALS';

export const fetchStatsMatchesGoals = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_MATCHES_GOALS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsMatchesGoals', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_MATCHES_GOALS});
        else dispatch({type: SUCCESS_FETCH_STATS_MATCHES_GOALS, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_MATCHES_GOALS) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_MATCHES_LINE_UP =
  'REQUEST_FETCH_STATS_MATCHES_LINE_UP';
export const SUCCESS_FETCH_STATS_MATCHES_LINE_UP =
  'SUCCESS_FETCH_STATS_MATCHES_LINE_UP';
export const FAIL_FETCH_STATS_MATCHES_LINE_UP =
  'FAIL_FETCH_STATS_MATCHES_LINE_UP';

export const fetchStatsMatchesLineUp = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_MATCHES_LINE_UP, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsMatchesLineUp', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_MATCHES_LINE_UP});
        else dispatch({type: SUCCESS_FETCH_STATS_MATCHES_LINE_UP, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_MATCHES_LINE_UP) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/matches.js